@if (clientLogoAsset2()) {
  <div class="sidenav-header">
    <img
      [width]="profilePicSize()"
      [height]="profilePicSize()"
      [src]="'../assets/' + clientLogoAsset2()"
    />
    @if (!collapsed()) {
      <div class="header-text">
        <h2>{{ heading() }}</h2>
        <p>{{ subTitle() }}</p>
      </div>
    }
  </div>
} @else {
  <div class="sidenav-no-logo"></div>
}
<mat-nav-list>
  @if(this.isLoggedIn())
  {
    @for (item of menuData(); track item.label) {
      <sqep-menu-item
        [item]="item"
        [collapsed]="false"
        [selected]="selectedMenuItem()"
        (changeCollapsedState)="changeCollapsedState.emit(true)"
        (selectedMenuItem)="selectedMenuItem.set($event)"
      ></sqep-menu-item>
    }
  }
</mat-nav-list>
